import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingVenue } from '../editor-booking-item-setting/editor-booking-item-setting-venue.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-venue',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryVenueComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingVenue;
  @Input() first: boolean;
  @Input() last: boolean;

  private destroyed$ = new Subject<void>();

  venueNames: { id: string, name: string }[];

  summary: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.venueNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(venueNames => {
        this.venueNames = venueNames;
        this.summary = this.getSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      if (this.venueNames !== undefined) {
        this.summary = this.getSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getSummary(): string {
    let summary = this.itemSetting.getIdAsString(this.venueNames);

    if (summary === '') {
      return summary;
    }

    summary = `at ${summary}`;

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
